import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../App";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Settings2, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

export const LookupManager = ({ lookupKey, title, token, onChanged, dir = "ltr", placeholder = "New item...", addLabel = "Add", triggerClassName = "" }) => {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [label, setLabel] = useState("");
  const headers = { Authorization: `Bearer ${token}` };

  const load = () => axios.get(`${API}/lookups/${lookupKey}`, { headers }).then(r => setItems(r.data || [])).catch(() => {});
  useEffect(() => { if (open) load(); }, [open]);

  const add = async () => {
    if (!label.trim()) return;
    try {
      await axios.post(`${API}/lookups/${lookupKey}`, { label }, { headers });
      setLabel("");
      load();
      onChanged?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed to add"); }
  };

  const remove = async (it) => {
    if (!window.confirm(dir === "rtl" ? `حذف "${it.label}"؟` : `Delete "${it.label}"?`)) return;
    try {
      await axios.delete(`${API}/lookups/${lookupKey}/${it.id}`, { headers });
      load();
      onChanged?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed to delete"); }
  };

  return (
    <>
      <Button type="button" size="sm" variant="ghost" onClick={() => setOpen(true)}
        className={`text-slate-400 hover:text-[#655dc6] h-8 w-8 p-0 ${triggerClassName}`}
        title={title} data-testid={`manage-${lookupKey}-btn`}>
        <Settings2 className="w-4 h-4" />
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent dir={dir} className="max-w-md">
          <DialogHeader><DialogTitle className="flex items-center gap-2 mx-6"><Settings2 className="w-5 h-5 text-[#655dc6]" /> {title}</DialogTitle></DialogHeader>
          <div className="flex gap-2">
            <Input value={label} onChange={e => setLabel(e.target.value)} placeholder={placeholder}
              onKeyDown={e => e.key === "Enter" && add()} data-testid={`lookup-new-${lookupKey}`} />
            <Button onClick={add} className="bg-[#655dc6] hover:bg-[#5449a8] text-white gap-1 shrink-0" data-testid={`lookup-add-${lookupKey}`}>
              <Plus className="w-4 h-4" /> {addLabel}
            </Button>
          </div>
          <div className="space-y-1.5 max-h-72 overflow-y-auto">
            {items.map(it => (
              <div key={it.id} className="flex items-center justify-between bg-slate-50 rounded-md px-3 py-1.5" data-testid={`lookup-row-${it.id}`}>
                <span className="text-sm">{it.label}</span>
                <Button size="sm" variant="ghost" onClick={() => remove(it)} className="text-red-400 h-7 w-7 p-0" data-testid={`lookup-del-${it.id}`}>
                  <Trash2 className="w-3.5 h-3.5" />
                </Button>
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
